import { GetUniqueOrigin, GetUniqueDestination, GetUniqueVessel, GetUniqueVoyage, } from '../OutBoundPdf/LLContent';
import { stableSort, getSorting } from '../../../Functions';
export function ULHeadCompose(page, rowL, ul, dataUrl) {
    var doc = ul;
    var _y = rowL;

    var imageX = 210;

    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, 55, 25);

    return _y;
}

export function ULBodyCompose(page, rowL, ul, data) {
    var doc = ul;
    var _y = rowL;
    var _space = page.spacingunit;

    let current_datetime = new Date()
    let formatted_date = (current_datetime.getMonth() + 1) + "/" + current_datetime.getDate() + "/" + current_datetime.getFullYear();
    var origin = GetUniqueOrigin(data.voyageBranches)
    var destination = GetUniqueDestination(data.voyageBranches)
    var vessel = GetUniqueVessel(data.voyageBranches)
    var voyage = GetUniqueVoyage(data.voyageBranches)

    doc.setFont("times", "bold");
    doc.text('OCEAN TRANSPORT GROUP OF COMPANIES INC.', 150, _y, null, null, 'center');
    doc.setFont("times", "normal");

    _y += _space;
    doc.text('UNLOAD LIST', 150, _y, null, null, 'center');

    _y += _space;
    doc.text(origin[0] + ' – ' + destination.join(' - '), 150, _y, null, null, 'center');
    _y += _space;
    doc.text('Vessel/Voyage No: ' + vessel[0] + ' ' + voyage[0], 150, _y, null, null, 'center');

    doc.text(20, _y, 'Date : ' + formatted_date);
    _y += _space * 2;

    return _y;
}

export function ULTableCompose(page, rowL, ul, data) {
    var doc = ul;
    var _y = rowL;
    var _space = page.spacingunit;

    doc.text(10, _y, 'Consignee');
    doc.text(80, _y, 'Container # / Commodity');
    doc.text(140, _y, 'Seal No');
    doc.text(170, _y, 'Service Mode');
    doc.text(200, _y, 'Status');
    doc.text(240, _y, 'Remark');
    doc.line(10, _y + 1, 270, _y + 1);
    _y += _space;

    // eslint-disable-next-line
    stableSort(data, getSorting('asc', 'consignee')).map(d => {
        var splitConsignee = doc.splitTextToSize(d.consignee ? d.consignee : '', 70);
        var splitSealNum = doc.splitTextToSize(d.sealNum ? d.sealNum : '', 30);
        var splitVanGoods = doc.splitTextToSize(d.containerVanNum ? d.containerVanNum : d.goods ? d.goods : '', 60);

        doc.text(10, _y, splitConsignee);
        doc.text(80, _y, splitVanGoods);
        doc.text(140, _y, splitSealNum);
        doc.text(170, _y, d.modeOfDelivery ? d.modeOfDelivery : '');
        doc.text(200, _y, d.releaseType ? d.releaseType : '');
        doc.text(240, _y, d.releaseTag ? d.releaseTag : '');

        if (splitConsignee.length > 1 && (splitConsignee.length >= splitSealNum.length || splitConsignee.length >= splitVanGoods.length)) {
            _y += _space * (splitConsignee.length - 1);
        }
        else if (splitVanGoods.length > 1 && (splitVanGoods.length >= splitConsignee.length || splitVanGoods.length >= splitSealNum.length)) {
            _y += _space * (splitVanGoods.length - 1);
        }
        else if (splitSealNum.length > 1 && (splitSealNum.length >= splitConsignee.length || splitSealNum.length >= splitVanGoods.length)) {
            _y += _space * (splitSealNum.length - 1);
        }

        doc.line(10, _y + 1, 270, _y + 1);
        _y += _space;
        if (_y >= 195) {
            doc.addPage(page.layoutL, page.papersize.unit, page.papersize.format);
            _y = 10;
            _y += _space * 2;

            doc.text(10, _y, 'Consignee');
            doc.text(80, _y, 'Container # / Commodity');
            doc.text(140, _y, 'Seal No');
            doc.text(170, _y, 'Service Mode');
            doc.text(200, _y, 'Status');
            doc.text(240, _y, 'Remark');
            doc.line(10, _y + 1, 270, _y + 1);
            _y += _space;
        }
    })
}